/* Global Shopify bottom beat player — seasonal JavaScript asset replacement */
(function () {
  "use strict";

  const STYLE_ID = "pc-sound-dock-styles";
  const BOOT_STYLE_ID = "pc-sound-dock-boot-styles";
  const STORAGE_KEY = "pc-global-sound-dock-v1";
  const SESSION_TOKEN_KEY = STORAGE_KEY + "-session-token";
  const NAVIGATION_RESUME_WINDOW = 60000;
  const RESUME_ACROSS_PAGES = true;

  /*
    PLAYER PAGE VISIBILITY
    The global bottom beat player is intentionally available ONLY on:
    - All Beats (/pages/beats)
    - Glo Banks
    - Skoo God
    - Supahoes

    Producer pages are Shopify pages. All Beats is allowed as either a Shopify
    page or collection so the dock still works if that route is ever changed
    between /pages/all-beats and /collections/all-beats.
  */
  const ALLOWED_PLAYER_PAGE_HANDLES = new Set([
    "beats",
    "all-beats",
    "glo-banks",
    "skoo-god",
    "supahoes"
  ]);

  function currentPageAllowsSoundDock() {
    let pathname = window.location.pathname || "/";

    try {
      pathname = decodeURIComponent(pathname);
    } catch (error) {}

    const segments = pathname
      .toLowerCase()
      .replace(/\/+$/, "")
      .split("/")
      .filter(Boolean);

    const pagesIndex = segments.lastIndexOf("pages");
    if (
      pagesIndex !== -1 &&
      segments[pagesIndex + 1] &&
      ALLOWED_PLAYER_PAGE_HANDLES.has(segments[pagesIndex + 1])
    ) {
      return true;
    }

    const collectionsIndex = segments.lastIndexOf("collections");
    if (
      collectionsIndex !== -1 &&
      segments[collectionsIndex + 1] === "all-beats"
    ) {
      return true;
    }

    return false;
  }

  function disableSoundDockForThisPage() {
    const hideStyle = document.createElement("style");
    hideStyle.id = "pc-sound-dock-page-visibility";
    hideStyle.textContent = `
      #pc-sticky-player {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }

      body.pc-has-sound-dock,
      body.pc-sound-dock-collapsed {
        padding-bottom: 0 !important;
      }
    `;
    (document.head || document.documentElement).appendChild(hideStyle);

    /*
      Disarm automatic cross-page resume while the dock is intentionally hidden.
      The saved selected beat remains available when the visitor returns to an
      allowed beat page, but it will not unexpectedly autoplay after the detour.
    */
    [window.sessionStorage, window.localStorage].forEach(function (storage) {
      try {
        const raw = storage.getItem(STORAGE_KEY);
        if (!raw) return;

        const saved = JSON.parse(raw);
        if (!saved || typeof saved !== "object") return;

        saved.shouldResume = false;
        saved.navigationArmed = false;
        saved.navigationSavedAt = 0;
        saved.savedAt = Date.now();
        storage.setItem(STORAGE_KEY, JSON.stringify(saved));
      } catch (error) {}
    });

    function removeDockIfPresent() {
      const sticky = document.getElementById("pc-sticky-player");
      if (sticky) sticky.remove();

      if (document.body) {
        document.body.classList.remove("pc-has-sound-dock");
        document.body.classList.remove("pc-sound-dock-collapsed");
      }
    }

    removeDockIfPresent();

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", removeDockIfPresent, { once: true });
    }
  }

  if (!currentPageAllowsSoundDock()) {
    disableSoundDockForThisPage();
    return;
  }
  /*
    Only actual beat-preview controls belong here. Generic data-audio buttons
    are intentionally excluded because free-download and modal action buttons
    can also carry an audio URL without being playback controls.
  */
  const PLAYER_SELECTOR = [
    ".beat-play-btn[data-audio]",
    ".beat-play-btn[data-audio-url]",
    ".beat-play-btn[data-track-url]",
    ".beat-play-btn[data-preview]",
    ".beat-play-btn[data-preview-url]",
    ".pc-row-play[data-audio]",
    ".pc-row-play[data-audio-url]",
    ".pc-row-play[data-track-url]",
    "[data-global-beat-play][data-audio]",
    "[data-global-beat-play][data-audio-url]",
    "[data-global-beat-play][data-track-url]"
  ].join(", ");

  const PAGE_CONTROL_SELECTOR = [
    "[id^=\"pc-main-play-\"]",
    "[id^=\"pc-prev-\"]",
    "[id^=\"pc-next-\"]"
  ].join(", ");

  /*
    The theme can render an existing #pc-sticky-player before this script has
    finished installing the final dock markup. Keep that uninitialized frame
    out of view so it cannot flash at the left edge during a reload.
  */
  function installBootStyles() {
    if (document.getElementById(BOOT_STYLE_ID)) return;

    const bootStyles = document.createElement("style");
    bootStyles.id = BOOT_STYLE_ID;
    bootStyles.textContent = `
      #pc-sticky-player {
        position: fixed !important;
        inset: auto 0 0 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100% !important;
        max-width: none !important;
        margin: 0 !important;
        transform: none !important;
      }

      #pc-sticky-player:not(.pc-sound-dock-ready) {
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
    `;

    (document.head || document.documentElement).appendChild(bootStyles);
  }

  installBootStyles();

  const PRODUCER_PAGE_PATH = /(?:^|\/)pages\/(glo-banks|skoo-god|supahoes)$/i;

  function normalizedProducerColor(value) {
    if (!value || !document.body) return null;

    const probe = document.createElement("span");
    probe.setAttribute("aria-hidden", "true");
    probe.style.cssText = "position:fixed;left:-9999px;top:-9999px;color:" + value + ";";
    document.body.appendChild(probe);

    const resolved = window.getComputedStyle(probe).color;
    probe.remove();

    const channels = resolved.match(/[\d.]+/g);
    if (!channels || channels.length < 3) return null;

    return [
      Math.round(Number(channels[0])),
      Math.round(Number(channels[1])),
      Math.round(Number(channels[2]))
    ];
  }

  function syncProducerDockAccent() {
    const root = document.documentElement;
    const currentPath = window.location.pathname.replace(/\/+$/, "");
    const isProducerPage = PRODUCER_PAGE_PATH.test(currentPath);

    if (!isProducerPage) {
      root.style.removeProperty("--pc-dock-producer-accent");
      root.style.removeProperty("--pc-dock-producer-accent-rgb");
      return;
    }

    const producerPlayer = document.querySelector('[id^="ProducerPlayer-"]');
    if (!producerPlayer) return;

    const playerStyles = window.getComputedStyle(producerPlayer);
    const pageColor = playerStyles.getPropertyValue("--pc-section-bg").trim();
    const rgb = normalizedProducerColor(pageColor || playerStyles.backgroundColor);
    if (!rgb) return;

    const rgbList = rgb.join(", ");
    root.style.setProperty("--pc-dock-producer-accent", "rgb(" + rgbList + ")");
    root.style.setProperty("--pc-dock-producer-accent-rgb", rgbList);
  }

  function installStyles() {
    const oldStyles = document.getElementById(STYLE_ID);
    if (oldStyles) oldStyles.remove();

    const styles = document.createElement("style");
    styles.id = STYLE_ID;
    styles.textContent = `
      :root {
        /* Producer pages replace only the blue accent layer; all other pages keep the seasonal theme. */
        --pc-dock-accent: var(--pc-dock-producer-accent, var(--pc-season-primary, #168cff));
        --pc-dock-accent-2: var(--pc-dock-producer-accent, var(--pc-season-secondary, #46b1ff));
        --pc-dock-bg: var(--pc-season-bg, #13151a);
        --pc-dock-panel: var(--pc-season-panel, #1a1d24);
        --pc-dock-card: var(--pc-season-card, #20242d);
        --pc-dock-text: var(--pc-season-text, #ffffff);
        --pc-dock-muted: var(--pc-season-muted, #9ca3b3);
        --pc-dock-button-text: var(--pc-season-button-text, #07111d);
        --pc-dock-line: rgba(var(--pc-season-border-rgb, 255, 255, 255), 0.34);
        --pc-dock-accent-rgb: var(--pc-dock-producer-accent-rgb, var(--pc-season-primary-rgb, 22, 140, 255));
        --pc-dock-height: 82px;
      }

      html {
        scroll-padding-bottom: var(--pc-dock-height);
      }

      body.pc-has-sound-dock {
        padding-bottom: var(--pc-dock-height) !important;
        transition: padding-bottom 0.24s ease !important;
      }

      body.pc-has-sound-dock.pc-sound-dock-collapsed {
        padding-bottom: calc(34px + env(safe-area-inset-bottom)) !important;
      }

      #pc-sticky-player.pc-sound-dock,
      #pc-sticky-player.pc-sound-dock * {
        box-sizing: border-box !important;
      }

      #pc-sticky-player.pc-sound-dock {
        position: fixed !important;
        z-index: 99999 !important;
        inset: auto 0 0 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        transform: none !important;
        width: 100% !important;
        max-width: none !important;
        min-width: 0 !important;
        height: var(--pc-dock-height) !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: visible !important;
        color: var(--pc-dock-text) !important;
        background: var(--pc-dock-bg) !important;
        background: color-mix(in srgb, var(--pc-dock-bg) 96%, var(--pc-dock-panel)) !important;
        border: 0 !important;
        border-top: 1px solid var(--pc-dock-line) !important;
        border-radius: 0 !important;
        box-shadow: 0 -14px 38px rgba(0, 0, 0, 0.36) !important;
        font-family: inherit !important;
        backdrop-filter: blur(18px);
        -webkit-backdrop-filter: blur(18px);
        will-change: transform;
        transition:
          transform 0.28s cubic-bezier(.22, 1, .36, 1),
          box-shadow 0.24s ease,
          border-color 0.24s ease !important;
      }

      #pc-sticky-player.pc-sound-dock.is-collapsed {
        transform: translateY(100%) !important;
        box-shadow: none !important;
      }

      #pc-sticky-player.pc-sound-dock.is-collapsed::before {
        opacity: 0 !important;
      }

      #pc-sticky-player .pc-dock-collapse-toggle {
        appearance: none !important;
        -webkit-appearance: none !important;
        position: absolute !important;
        z-index: 5 !important;
        top: -34px !important;
        left: 50% !important;
        display: grid !important;
        place-items: center !important;
        width: 62px !important;
        height: 34px !important;
        margin: 0 !important;
        padding: 0 !important;
        transform: translateX(-50%) !important;
        color: var(--pc-dock-text) !important;
        background:
          linear-gradient(180deg, color-mix(in srgb, var(--pc-dock-panel) 96%, transparent), color-mix(in srgb, var(--pc-dock-bg) 98%, transparent)) !important;
        border: 1px solid var(--pc-dock-line) !important;
        border-bottom: 0 !important;
        border-radius: 12px 12px 0 0 !important;
        box-shadow: 0 -8px 22px rgba(0, 0, 0, 0.28) !important;
        cursor: pointer !important;
        touch-action: manipulation !important;
        -webkit-tap-highlight-color: transparent !important;
        transition:
          color 0.18s ease,
          background 0.18s ease,
          border-color 0.18s ease,
          transform 0.18s ease !important;
      }

      #pc-sticky-player .pc-dock-collapse-toggle::before {
        content: "" !important;
        position: absolute !important;
        top: 5px !important;
        left: 50% !important;
        width: 18px !important;
        height: 2px !important;
        transform: translateX(-50%) !important;
        border-radius: 999px !important;
        background: var(--pc-dock-accent) !important;
        opacity: 0.82 !important;
        box-shadow: 0 0 10px rgba(var(--pc-dock-accent-rgb), 0.32) !important;
      }

      #pc-sticky-player .pc-dock-collapse-toggle:hover {
        color: var(--pc-dock-accent) !important;
        border-color: rgba(var(--pc-dock-accent-rgb), 0.58) !important;
      }

      #pc-sticky-player .pc-dock-collapse-toggle:focus-visible {
        outline: 2px solid var(--pc-dock-accent) !important;
        outline-offset: 2px !important;
      }

      #pc-sticky-player .pc-dock-collapse-toggle .pc-dock-icon {
        display: block !important;
        width: 19px !important;
        height: 19px !important;
        margin-top: 4px !important;
        transform: rotate(0deg) !important;
        transform-origin: center !important;
        transition: transform 0.24s cubic-bezier(.22, 1, .36, 1) !important;
      }

      /*
        ONE ARROW ONLY:
        - Player open: chevron points DOWN to hide the player.
        - Player hidden: the same chevron rotates UP to reopen it.
      */
      #pc-sticky-player.is-collapsed .pc-dock-collapse-toggle .pc-dock-icon {
        transform: rotate(180deg) !important;
      }

      #pc-sticky-player.is-collapsed .pc-dock-collapse-toggle {
        color: var(--pc-dock-accent) !important;
        border-color: rgba(var(--pc-dock-accent-rgb), 0.58) !important;
        box-shadow:
          0 -8px 24px rgba(0, 0, 0, 0.32),
          0 0 18px rgba(var(--pc-dock-accent-rgb), 0.13) !important;
      }

      #pc-sticky-player.is-collapsed .pc-dock-inner {
        opacity: 0 !important;
        pointer-events: none !important;
      }

      #pc-sticky-player.pc-sound-dock::before {
        content: "";
        position: absolute;
        z-index: 2;
        top: -1px;
        left: 0;
        width: 100%;
        height: 2px;
        pointer-events: none;
        background: linear-gradient(90deg, transparent, var(--pc-dock-accent) 24%, var(--pc-dock-accent-2) 50%, var(--pc-dock-accent) 76%, transparent);
        box-shadow: 0 0 18px rgba(var(--pc-dock-accent-rgb), 0.48);
      }

      #pc-sticky-player .pc-dock-inner {
        width: min(1500px, 100%) !important;
        height: 100% !important;
        min-width: 0 !important;
        margin: 0 auto !important;
        padding: 0 28px !important;
        display: grid !important;
        grid-template-columns: auto minmax(260px, 1fr) minmax(220px, 300px) minmax(130px, 175px) !important;
        grid-template-areas: "transport timeline track volume" !important;
        align-items: center !important;
        gap: clamp(18px, 2.2vw, 34px) !important;
      }

      #pc-sticky-player .pc-dock-transport {
        grid-area: transport !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 7px !important;
        min-width: 0 !important;
      }

      #pc-sticky-player .pc-dock-button {
        appearance: none !important;
        -webkit-appearance: none !important;
        display: inline-grid !important;
        flex: 0 0 auto !important;
        place-items: center !important;
        width: 36px !important;
        min-width: 36px !important;
        height: 36px !important;
        min-height: 36px !important;
        margin: 0 !important;
        padding: 0 !important;
        color: var(--pc-dock-text) !important;
        background: transparent !important;
        border: 1px solid transparent !important;
        border-radius: 10px !important;
        box-shadow: none !important;
        line-height: 1 !important;
        cursor: pointer !important;
        transition: color 0.18s ease, background 0.18s ease, transform 0.18s ease, border-color 0.18s ease !important;
      }

      #pc-sticky-player .pc-dock-button:hover {
        color: var(--pc-dock-text) !important;
        background: rgba(var(--pc-dock-accent-rgb), 0.11) !important;
        border-color: var(--pc-dock-line) !important;
        transform: translateY(-1px) !important;
      }

      #pc-sticky-player .pc-dock-button:focus-visible {
        outline: 2px solid var(--pc-dock-accent) !important;
        outline-offset: 2px !important;
      }

      #pc-sticky-player .pc-dock-button:disabled,
      #pc-sticky-player .pc-dock-range:disabled {
        cursor: not-allowed !important;
        opacity: 0.38 !important;
      }

      #pc-sticky-player .pc-dock-button:disabled:hover {
        color: rgba(255, 255, 255, 0.82) !important;
        background: transparent !important;
        border-color: transparent !important;
        transform: none !important;
      }

      #pc-sticky-player #pc-player-toggle.pc-dock-play {
        width: 46px !important;
        min-width: 46px !important;
        height: 46px !important;
        min-height: 46px !important;
        color: var(--pc-dock-button-text) !important;
        background: var(--pc-dock-accent) !important;
        border: 0 !important;
        border-radius: 50% !important;
        box-shadow: 0 8px 22px rgba(0, 0, 0, 0.32) !important;
      }

      #pc-sticky-player #pc-player-toggle.pc-dock-play:hover {
        color: #fff !important;
        background: var(--pc-dock-accent) !important;
        transform: scale(1.05) !important;
        box-shadow: 0 9px 25px rgba(var(--pc-dock-accent-rgb), 0.34) !important;
      }

      #pc-sticky-player .pc-dock-icon {
        display: block !important;
        width: 18px !important;
        height: 18px !important;
        fill: currentColor !important;
        stroke: currentColor !important;
        stroke-width: 1.8 !important;
        stroke-linecap: round !important;
        stroke-linejoin: round !important;
      }

      #pc-sticky-player .pc-dock-pause-icon,
      #pc-sticky-player .pc-dock-muted-icon {
        display: none !important;
      }

      #pc-sticky-player.is-playing .pc-dock-play-icon {
        display: none !important;
      }

      #pc-sticky-player.is-playing .pc-dock-pause-icon {
        display: block !important;
      }

      #pc-sticky-player.is-resume-pending #pc-player-toggle.pc-dock-play {
        color: #fff !important;
        background: var(--pc-dock-accent) !important;
        box-shadow:
          0 0 0 4px rgba(var(--pc-dock-accent-rgb), 0.14) !important,
          0 0 24px rgba(var(--pc-dock-accent-rgb), 0.36) !important;
        animation: pcDockResumePulse 1.35s ease-in-out infinite !important;
      }

      @keyframes pcDockResumePulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.06); }
      }

      #pc-sticky-player.is-muted .pc-dock-volume-icon {
        display: none !important;
      }

      #pc-sticky-player.is-muted .pc-dock-muted-icon {
        display: block !important;
      }

      #pc-sticky-player .pc-dock-timeline {
        grid-area: timeline !important;
        display: grid !important;
        grid-template-columns: 38px minmax(0, 1fr) 38px !important;
        align-items: center !important;
        gap: 10px !important;
        width: 100% !important;
        min-width: 0 !important;
        margin: 0 !important;
      }

      #pc-sticky-player .pc-dock-time {
        display: block !important;
        min-width: 0 !important;
        margin: 0 !important;
        color: var(--pc-dock-muted) !important;
        font-size: 11px !important;
        font-weight: 700 !important;
        font-variant-numeric: tabular-nums !important;
        letter-spacing: 0 !important;
        line-height: 1 !important;
        opacity: 1 !important;
        white-space: nowrap !important;
      }

      #pc-sticky-player #pc-current-time {
        text-align: right !important;
      }

      #pc-sticky-player #pc-duration {
        text-align: left !important;
      }

      #pc-sticky-player .pc-dock-range {
        --pc-dock-fill: 0%;
        appearance: none !important;
        -webkit-appearance: none !important;
        display: block !important;
        width: 100% !important;
        min-width: 0 !important;
        height: 20px !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        outline: 0 !important;
        cursor: pointer !important;
        background: transparent !important;
        box-shadow: none !important;
        accent-color: var(--pc-dock-accent) !important;
      }

      #pc-sticky-player .pc-dock-range::-webkit-slider-runnable-track {
        width: 100% !important;
        height: 4px !important;
        border: 0 !important;
        border-radius: 999px !important;
        background: linear-gradient(90deg, var(--pc-dock-accent) 0 var(--pc-dock-fill), var(--pc-dock-card) var(--pc-dock-fill) 100%) !important;
      }

      #pc-sticky-player .pc-dock-range::-webkit-slider-thumb {
        appearance: none !important;
        -webkit-appearance: none !important;
        width: 13px !important;
        height: 13px !important;
        margin-top: -4.5px !important;
        border: 2px solid var(--pc-dock-text) !important;
        border-radius: 50% !important;
        background: var(--pc-dock-accent) !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.38) !important;
      }

      #pc-sticky-player .pc-dock-range::-moz-range-track {
        height: 4px !important;
        border: 0 !important;
        border-radius: 999px !important;
        background: var(--pc-dock-card) !important;
      }

      #pc-sticky-player .pc-dock-range::-moz-range-progress {
        height: 4px !important;
        border-radius: 999px !important;
        background: var(--pc-dock-accent) !important;
      }

      #pc-sticky-player .pc-dock-range::-moz-range-thumb {
        width: 13px !important;
        height: 13px !important;
        border: 2px solid var(--pc-dock-text) !important;
        border-radius: 50% !important;
        background: var(--pc-dock-accent) !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.38) !important;
      }

      #pc-sticky-player .pc-dock-track {
        grid-area: track !important;
        display: grid !important;
        grid-template-columns: 48px minmax(0, 1fr) !important;
        align-items: center !important;
        gap: 11px !important;
        min-width: 0 !important;
        padding: 7px 10px 7px 7px !important;
        overflow: hidden !important;
        background: var(--pc-dock-panel) !important;
        background: color-mix(in srgb, var(--pc-dock-panel) 92%, transparent) !important;
        border: 1px solid var(--pc-dock-line) !important;
        border-radius: 12px !important;
      }

      #pc-sticky-player .pc-dock-cover {
        position: relative !important;
        width: 48px !important;
        min-width: 48px !important;
        height: 48px !important;
        min-height: 48px !important;
        overflow: hidden !important;
        background: linear-gradient(145deg, var(--pc-dock-card), var(--pc-dock-panel)) !important;
        border-radius: 8px !important;
      }

      #pc-sticky-player .pc-dock-cover::after {
        content: "";
        position: absolute;
        inset: 0;
        pointer-events: none;
        border: 1px solid var(--pc-dock-line);
        border-radius: inherit;
      }

      #pc-sticky-player .pc-dock-cover img {
        display: block !important;
        width: 100% !important;
        height: 100% !important;
        max-width: none !important;
        object-fit: cover !important;
      }

      #pc-sticky-player .pc-dock-cover-fallback {
        display: grid !important;
        place-items: center !important;
        width: 100% !important;
        height: 100% !important;
        color: var(--pc-dock-muted) !important;
      }

      #pc-sticky-player .pc-dock-cover-fallback .pc-dock-icon {
        width: 20px !important;
        height: 20px !important;
      }

      #pc-sticky-player .pc-dock-copy {
        min-width: 0 !important;
        overflow: hidden !important;
      }

      #pc-sticky-player #pc-player-title,
      #pc-sticky-player #pc-player-meta {
        display: block !important;
        width: 100% !important;
        min-width: 0 !important;
        margin: 0 !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
      }

      #pc-sticky-player #pc-player-title {
        color: var(--pc-dock-text) !important;
        font-size: 13px !important;
        font-weight: 800 !important;
        line-height: 1.25 !important;
      }

      #pc-sticky-player #pc-player-meta {
        margin-top: 4px !important;
        color: var(--pc-dock-muted) !important;
        font-size: 11px !important;
        font-weight: 600 !important;
        line-height: 1.2 !important;
        opacity: 1 !important;
      }

      #pc-sticky-player .pc-dock-status {
        display: flex !important;
        align-items: center !important;
        gap: 4px !important;
        margin-top: 5px !important;
        height: 8px !important;
      }

      #pc-sticky-player .pc-dock-status span {
        width: 2px !important;
        height: 3px !important;
        background: var(--pc-dock-accent) !important;
        border-radius: 999px !important;
        opacity: 0.55 !important;
        transform-origin: center bottom !important;
      }

      #pc-sticky-player.is-playing .pc-dock-status span {
        opacity: 1 !important;
        animation: pcDockPulse 0.8s ease-in-out infinite alternate !important;
      }

      #pc-sticky-player.is-playing .pc-dock-status span:nth-child(2) { animation-delay: -0.55s !important; }
      #pc-sticky-player.is-playing .pc-dock-status span:nth-child(3) { animation-delay: -0.25s !important; }
      #pc-sticky-player.is-playing .pc-dock-status span:nth-child(4) { animation-delay: -0.68s !important; }

      @keyframes pcDockPulse {
        from { transform: scaleY(0.7); }
        to { transform: scaleY(2.6); }
      }

      #pc-sticky-player .pc-dock-volume {
        grid-area: volume !important;
        display: grid !important;
        grid-template-columns: 34px minmax(0, 1fr) !important;
        align-items: center !important;
        gap: 8px !important;
        min-width: 0 !important;
      }

      #pc-sticky-player #pc-player-mute {
        width: 34px !important;
        min-width: 34px !important;
        height: 34px !important;
        min-height: 34px !important;
      }

      #pc-sticky-player #pc-player-volume {
        --pc-dock-fill: 85%;
        grid-column: auto !important;
        grid-row: auto !important;
        display: block !important;
        width: 100% !important;
        max-width: none !important;
        min-width: 0 !important;
        margin: 0 !important;
        opacity: 1 !important;
      }

      @media screen and (max-width: 920px) {
        :root {
          --pc-dock-height: 78px;
        }

        #pc-sticky-player .pc-dock-inner {
          padding: 0 18px !important;
          grid-template-columns: auto minmax(210px, 1fr) minmax(180px, 235px) !important;
          grid-template-areas: "transport timeline track" !important;
          gap: 16px !important;
        }

        #pc-sticky-player .pc-dock-volume {
          display: none !important;
        }
      }

      @media screen and (max-width: 749px) {
        :root {
          --pc-dock-height: calc(128px + env(safe-area-inset-bottom));
        }

        #pc-sticky-player.pc-sound-dock {
          height: var(--pc-dock-height) !important;
          padding-bottom: env(safe-area-inset-bottom) !important;
        }

        #pc-sticky-player .pc-dock-inner {
          width: 100% !important;
          height: 128px !important;
          padding: 10px 12px 9px !important;
          grid-template-columns: minmax(0, 1fr) auto !important;
          grid-template-rows: 48px 26px 24px !important;
          grid-template-areas:
            "track transport"
            "timeline timeline"
            "volume volume" !important;
          column-gap: 10px !important;
          row-gap: 5px !important;
        }

        #pc-sticky-player .pc-dock-track {
          grid-template-columns: 42px minmax(0, 1fr) !important;
          gap: 9px !important;
          height: 48px !important;
          padding: 3px !important;
          background: transparent !important;
          border: 0 !important;
          border-radius: 0 !important;
        }

        #pc-sticky-player .pc-dock-cover {
          width: 42px !important;
          min-width: 42px !important;
          height: 42px !important;
          min-height: 42px !important;
          border-radius: 7px !important;
        }

        #pc-sticky-player #pc-player-title {
          font-size: 13px !important;
        }

        #pc-sticky-player #pc-player-meta {
          margin-top: 3px !important;
          font-size: 10px !important;
        }

        #pc-sticky-player .pc-dock-status {
          display: none !important;
        }

        #pc-sticky-player .pc-dock-transport {
          gap: 3px !important;
        }

        #pc-sticky-player .pc-dock-button {
          width: 38px !important;
          min-width: 38px !important;
          height: 38px !important;
          min-height: 38px !important;
          border-radius: 10px !important;
          touch-action: manipulation !important;
          -webkit-tap-highlight-color: transparent !important;
        }

        #pc-sticky-player #pc-player-toggle.pc-dock-play {
          width: 44px !important;
          min-width: 44px !important;
          height: 44px !important;
          min-height: 44px !important;
        }

        #pc-sticky-player .pc-dock-range {
          height: 28px !important;
          touch-action: pan-x !important;
        }

        #pc-sticky-player .pc-dock-collapse-toggle {
          top: -36px !important;
          width: 66px !important;
          height: 36px !important;
          border-radius: 13px 13px 0 0 !important;
        }

        #pc-sticky-player .pc-dock-timeline {
          grid-template-columns: 33px minmax(0, 1fr) 33px !important;
          gap: 7px !important;
          align-self: center !important;
        }

        #pc-sticky-player .pc-dock-time {
          font-size: 10px !important;
        }

        #pc-sticky-player .pc-dock-volume {
          display: grid !important;
          grid-template-columns: 28px 92px !important;
          justify-content: end !important;
          gap: 6px !important;
          width: auto !important;
        }

        #pc-sticky-player #pc-player-mute {
          width: 36px !important;
          min-width: 36px !important;
          height: 36px !important;
          min-height: 36px !important;
        }
      }

      @media screen and (max-width: 390px) {
        #pc-sticky-player .pc-dock-inner {
          padding-right: 9px !important;
          padding-left: 9px !important;
          column-gap: 6px !important;
        }

        #pc-sticky-player .pc-dock-cover {
          display: none !important;
        }

        #pc-sticky-player .pc-dock-track {
          grid-template-columns: minmax(0, 1fr) !important;
        }

        #pc-sticky-player .pc-dock-button {
          width: 34px !important;
          min-width: 34px !important;
          height: 36px !important;
          min-height: 36px !important;
        }

        #pc-sticky-player #pc-player-toggle.pc-dock-play {
          width: 44px !important;
          min-width: 44px !important;
          height: 44px !important;
          min-height: 44px !important;
        }

        #pc-sticky-player .pc-dock-collapse-toggle {
          width: 62px !important;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        #pc-sticky-player *,
        #pc-sticky-player *::before,
        #pc-sticky-player *::after {
          animation-duration: 0.01ms !important;
          animation-iteration-count: 1 !important;
          scroll-behavior: auto !important;
          transition-duration: 0.01ms !important;
        }

        body.pc-has-sound-dock {
          transition-duration: 0.01ms !important;
        }
      }
    `;

    document.head.appendChild(styles);
  }

  function playerMarkup() {
    return `
      <button
        type="button"
        id="pc-player-collapse"
        class="pc-dock-collapse-toggle"
        aria-label="Hide player"
        aria-expanded="true"
        aria-controls="pc-player-dock-content"
        title="Hide player"
      >
        <svg class="pc-dock-icon pc-dock-collapse-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="m6 9 6 6 6-6" fill="none"/>
        </svg>
      </button>

      <div class="pc-dock-inner" id="pc-player-dock-content">
        <div class="pc-dock-transport" aria-label="Playback controls">
          <button type="button" id="pc-player-prev" class="pc-dock-button" aria-label="Previous track">
            <svg class="pc-dock-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5v14M18 6l-8 6 8 6V6Z" fill="currentColor" stroke="none"/></svg>
          </button>

          <button type="button" id="pc-player-toggle" class="pc-dock-button pc-dock-play" aria-label="Play track">
            <svg class="pc-dock-icon pc-dock-play-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="m8 5 11 7-11 7V5Z" fill="currentColor" stroke="none"/></svg>
            <svg class="pc-dock-icon pc-dock-pause-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h4v14H7V5Zm6 0h4v14h-4V5Z" fill="currentColor" stroke="none"/></svg>
          </button>

          <button type="button" id="pc-player-next" class="pc-dock-button" aria-label="Next track">
            <svg class="pc-dock-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M17 5v14M6 6l8 6-8 6V6Z" fill="currentColor" stroke="none"/></svg>
          </button>
        </div>

        <div class="pc-dock-timeline">
          <span id="pc-current-time" class="pc-dock-time">0:00</span>
          <input id="pc-progress" class="pc-dock-range" type="range" min="0" max="100" step="0.01" value="0" aria-label="Track progress">
          <span id="pc-duration" class="pc-dock-time">0:00</span>
        </div>

        <div class="pc-dock-track">
          <div class="pc-dock-cover" aria-hidden="true">
            <img id="pc-player-cover" alt="" hidden>
            <span id="pc-player-cover-fallback" class="pc-dock-cover-fallback">
              <svg class="pc-dock-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 18V5l10-2v13M9 9l10-2M6.5 21A3.5 3.5 0 1 0 6.5 14a3.5 3.5 0 0 0 0 7Zm10-2A3.5 3.5 0 1 0 16.5 12a3.5 3.5 0 0 0 0 7Z" fill="none"/></svg>
            </span>
          </div>

          <div class="pc-dock-copy" aria-live="polite" aria-atomic="true">
            <strong id="pc-player-title">Select a beat</strong>
            <span id="pc-player-meta">Preview player</span>
            <span class="pc-dock-status" aria-hidden="true"><span></span><span></span><span></span><span></span></span>
          </div>
        </div>

        <div class="pc-dock-volume">
          <button type="button" id="pc-player-mute" class="pc-dock-button" aria-label="Mute track" aria-pressed="false">
            <svg class="pc-dock-icon pc-dock-volume-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10v4h4l5 4V6l-5 4H4Z" fill="currentColor" stroke="none"/><path d="M16 9a4 4 0 0 1 0 6M18.5 6.5a7.5 7.5 0 0 1 0 11" fill="none"/></svg>
            <svg class="pc-dock-icon pc-dock-muted-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10v4h4l5 4V6l-5 4H4Z" fill="currentColor" stroke="none"/><path d="m16 10 4 4m0-4-4 4" fill="none"/></svg>
          </button>
          <input id="pc-player-volume" class="pc-dock-range" type="range" min="0" max="1" step="0.01" value="0.85" aria-label="Volume">
        </div>
      </div>
    `;
  }

  function formatTime(seconds) {
    if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60).toString().padStart(2, "0");
    return minutes + ":" + secs;
  }

  function setRangeFill(input, percentage) {
    if (!input) return;
    const safePercentage = Math.max(0, Math.min(100, Number(percentage) || 0));
    input.style.setProperty("--pc-dock-fill", safePercentage + "%");
  }

  function absoluteUrl(value) {
    if (!value) return "";

    try {
      return new URL(value, window.location.href).href;
    } catch (error) {
      return String(value);
    }
  }

  function parseSavedState(value) {
    try {
      const parsed = value ? JSON.parse(value) : {};
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function readState() {
    let sessionState = {};
    let localState = {};

    try {
      sessionState = parseSavedState(window.sessionStorage.getItem(STORAGE_KEY));
    } catch (error) {}

    try {
      localState = parseSavedState(window.localStorage.getItem(STORAGE_KEY));
    } catch (error) {}

    /*
      iOS Safari can occasionally discard sessionStorage while restoring a tab.
      Keep a localStorage mirror and choose whichever copy was saved most recently.
    */
    const sessionSavedAt = Number(sessionState.savedAt) || 0;
    const localSavedAt = Number(localState.savedAt) || 0;

    return localSavedAt > sessionSavedAt ? localState : sessionState;
  }

  function writeState(state) {
    const serialized = JSON.stringify(state);

    try {
      window.sessionStorage.setItem(STORAGE_KEY, serialized);
    } catch (error) {}

    try {
      window.localStorage.setItem(STORAGE_KEY, serialized);
    } catch (error) {
      /* Storage can be unavailable in private browsing; the player still works. */
    }
  }

  function getSessionToken() {
    try {
      let token = window.sessionStorage.getItem(SESSION_TOKEN_KEY);

      if (!token) {
        token =
          (window.crypto && typeof window.crypto.randomUUID === "function")
            ? window.crypto.randomUUID()
            : String(Date.now()) + "-" + Math.random().toString(36).slice(2);

        window.sessionStorage.setItem(SESSION_TOKEN_KEY, token);
      }

      return token;
    } catch (error) {
      /*
        Storage can be unavailable in private browsing. A temporary token still
        prevents saved playback from activating automatically on this load.
      */
      return String(Date.now()) + "-" + Math.random().toString(36).slice(2);
    }
  }

  function ensureStickyPlayer() {
    let sticky = document.getElementById("pc-sticky-player");

    if (!sticky) {
      sticky = document.createElement("aside");
      sticky.id = "pc-sticky-player";
      document.body.appendChild(sticky);
    }

    sticky.setAttribute("aria-label", "Beat preview player");
    return sticky;
  }

  function getAudioSource(audio) {
    if (!audio) return "";
    const source = audio.querySelector("source[src]");
    return absoluteUrl(audio.currentSrc || audio.getAttribute("src") || (source && source.getAttribute("src")) || "");
  }

  function ensureAudio(section, state) {
    let audio = document.getElementById("pc-global-audio");

    /*
      Use one shared audio element on every page. Producer pages include a
      legacy pc-audio-* element, so promote that same node instead of creating
      a second player. This keeps a restored beat out of the new producer
      page's local playlist state while still letting its controls use the
      global player after a visitor selects one of that page's tracks.
    */
    if (!audio && section) {
      audio = section.querySelector('[id^="pc-audio-"]');
      if (audio) audio.id = "pc-global-audio";
    }

    if (!audio) {
      audio = document.createElement("audio");
      audio.id = "pc-global-audio";
      document.body.appendChild(audio);
    }

    audio.preload = "auto";
    audio.playsInline = true;
    audio.setAttribute("playsinline", "");
    audio.setAttribute("webkit-playsinline", "");
    audio.setAttribute("data-pc-shared-audio", "true");
    audio.hidden = true;

    if (state.src) {
      audio.dataset.pcTrackId = state.trackId || absoluteUrl(state.src);
      audio.dataset.pcOwnerKey = state.ownerKey || ("saved:" + (state.sessionToken || "unknown"));

      if (getAudioSource(audio) !== absoluteUrl(state.src)) {
        audio.src = state.src;
        try { audio.load(); } catch (error) {}
      }
    } else {
      delete audio.dataset.pcTrackId;
      delete audio.dataset.pcOwnerKey;
    }

    return { audio: audio, isFallback: true };
  }

  function dataValue(nodes, attributeNames) {
    for (let nodeIndex = 0; nodeIndex < nodes.length; nodeIndex += 1) {
      const node = nodes[nodeIndex];
      if (!node || !node.getAttribute) continue;

      for (let nameIndex = 0; nameIndex < attributeNames.length; nameIndex += 1) {
        const value = node.getAttribute(attributeNames[nameIndex]);
        if (value && value.trim()) return value.trim();
      }
    }

    return "";
  }

  function buttonDetails(button) {
    const row = button.closest("[data-audio], [data-audio-url], [data-track-url], .pc-beat-row, .pc-row, .beat-row") || button.parentElement;
    const owner = button.closest("[data-player-owner]");
    const nodes = [button, row, owner];

    return {
      src: dataValue(nodes, ["data-audio", "data-audio-url", "data-track-url", "data-preview", "data-preview-url", "data-src"]),
      title: dataValue(nodes, ["data-title", "data-track-title", "data-name"]),
      meta: dataValue(nodes, ["data-producer", "data-artist", "data-meta"]),
      cover: dataValue(nodes, ["data-cover", "data-cover-url", "data-image", "data-artwork"]),
      trackId: dataValue(nodes, ["data-track-id", "data-product-id"]),
      ownerKey: dataValue(nodes, ["data-player-owner", "data-page-key"])
    };
  }

  function meaningfulText(element, ignoredValues) {
    if (!element) return "";
    const value = element.textContent.trim();
    if (!value) return "";

    const normalized = value.toLowerCase();
    return ignoredValues.indexOf(normalized) === -1 ? value : "";
  }

  function initSoundDock(force) {
    if (window.__pcSoundDockCleanup) {
      if (!force) return;
      window.__pcSoundDockCleanup();
    }

    syncProducerDockAccent();
    installStyles();

    const sticky = ensureStickyPlayer();
    const state = readState();
    const sessionToken = getSessionToken();
    const now = Date.now();

    if (typeof state.userPaused !== "boolean") state.userPaused = false;
    if (typeof state.trackEnded !== "boolean") state.trackEnded = false;
    if (typeof state.hasUserSelected !== "boolean") state.hasUserSelected = false;
    if (typeof state.dockCollapsed !== "boolean") state.dockCollapsed = false;
    if (typeof state.navigationArmed !== "boolean") state.navigationArmed = false;
    if (!Number.isFinite(Number(state.currentTime))) state.currentTime = 0;
    if (!Number.isFinite(Number(state.duration))) state.duration = 0;

    const sameTabSelection = Boolean(
      state.hasUserSelected &&
      state.sessionToken &&
      state.sessionToken === sessionToken &&
      state.src
    );

    const recentNavigation = Boolean(
      RESUME_ACROSS_PAGES &&
      sameTabSelection &&
      state.navigationArmed &&
      Number(state.navigationSavedAt) > 0 &&
      now - Number(state.navigationSavedAt) <= NAVIGATION_RESUME_WINDOW
    );

    if (!sameTabSelection) {
      state.src = "";
      state.trackId = "";
      state.ownerKey = "";
      state.title = "Select a beat";
      state.meta = "Preview player";
      state.cover = "";
      state.currentTime = 0;
      state.duration = 0;
      state.shouldResume = false;
      state.hasUserSelected = false;
      state.navigationArmed = false;
      state.navigationSavedAt = 0;
      state.userPaused = false;
      state.trackEnded = false;
      state.sessionToken = sessionToken;
      writeState(state);
    } else if (!recentNavigation) {
      /* Keep the chosen beat visible after a reload, but do not autoplay it. */
      state.shouldResume = false;
      state.navigationArmed = false;
      state.navigationSavedAt = 0;
      writeState(state);
    }

    const section = document.querySelector(".pc-player-2026");
    const audioResult = ensureAudio(section, state);
    const audio = audioResult.audio;
    const isFallbackAudio = audioResult.isFallback;
    const controller = new AbortController();
    const signal = controller.signal;
    const observers = [];
    const timers = new Set();

    sticky.className = "pc-sound-dock";
    sticky.removeAttribute("style");
    sticky.innerHTML = playerMarkup();
    document.body.classList.add("pc-has-sound-dock");
    sticky.classList.add("pc-sound-dock-ready");

    const stickyTitle = sticky.querySelector("#pc-player-title");
    const stickyMeta = sticky.querySelector("#pc-player-meta");
    const stickyCover = sticky.querySelector("#pc-player-cover");
    const stickyCoverFallback = sticky.querySelector("#pc-player-cover-fallback");
    const stickyToggle = sticky.querySelector("#pc-player-toggle");
    const stickyPrev = sticky.querySelector("#pc-player-prev");
    const stickyNext = sticky.querySelector("#pc-player-next");
    const stickyProgress = sticky.querySelector("#pc-progress");
    const stickyCurrent = sticky.querySelector("#pc-current-time");
    const stickyDuration = sticky.querySelector("#pc-duration");
    const stickyVolume = sticky.querySelector("#pc-player-volume");
    const stickyMute = sticky.querySelector("#pc-player-mute");
    const stickyCollapse = sticky.querySelector("#pc-player-collapse");
    const stickyInner = sticky.querySelector("#pc-player-dock-content");

    const topVolume = section && section.querySelector('[id^="pc-volume-"]');

    let activeButton = null;
    let lastCoverUrl = "";
    let lastSaveTime = 0;
    let pendingRestoreTime = Number(state.currentTime) || 0;
    let resumeRequested = Boolean(
      recentNavigation &&
      state.src &&
      !state.userPaused &&
      !state.trackEnded
    );
    let resumeListenersInstalled = false;
    let pageIsLeaving = false;
    let navigationResetTimer = 0;
    let capturedTrackIntent = null;
    let capturedPageControlIntent = null;
    let endedTimer = 0;

    function later(callback, delay) {
      const timer = window.setTimeout(function () {
        timers.delete(timer);
        callback();
      }, delay);
      timers.add(timer);
      return timer;
    }

    function applyDockCollapsed(collapsed, shouldPersist) {
      const nextCollapsed = Boolean(collapsed);
      state.dockCollapsed = nextCollapsed;

      sticky.classList.toggle("is-collapsed", nextCollapsed);
      document.body.classList.toggle("pc-sound-dock-collapsed", nextCollapsed);

      if (stickyCollapse) {
        stickyCollapse.setAttribute("aria-expanded", nextCollapsed ? "false" : "true");
        stickyCollapse.setAttribute("aria-label", nextCollapsed ? "Show player" : "Hide player");
        stickyCollapse.title = nextCollapsed ? "Show player" : "Hide player";
      }

      if (stickyInner) {
        stickyInner.setAttribute("aria-hidden", nextCollapsed ? "true" : "false");
        if ("inert" in stickyInner) stickyInner.inert = nextCollapsed;
      }

      if (shouldPersist) {
        persistState(true);
      }
    }

    applyDockCollapsed(state.dockCollapsed, false);

    if (Number.isFinite(Number(state.volume))) {
      try {
        audio.volume = Math.max(0, Math.min(1, Number(state.volume)));
      } catch (error) {
        /* Some mobile browsers do not allow scripted volume changes. */
      }
    }

    function currentSource() {
      return getAudioSource(audio);
    }

    function savedSource() {
      return absoluteUrl(state.src || "");
    }

    function buttonMatchesCurrentAudio(button) {
      if (!button) return false;
      const details = buttonDetails(button);
      const source = absoluteUrl(details.src || "");
      const audioTrackId = audio.dataset.pcTrackId || "";
      const audioOwnerKey = audio.dataset.pcOwnerKey || "";

      if (!source || currentSource() !== source) return false;
      if (audioTrackId && details.trackId && audioTrackId !== details.trackId) return false;
      if (audioOwnerKey && details.ownerKey && audioOwnerKey !== details.ownerKey) return false;
      return true;
    }

    function buttonMatchesSavedState(button) {
      if (!button) return false;
      const details = buttonDetails(button);
      const source = absoluteUrl(details.src || "");

      if (!source || source !== savedSource()) return false;
      if (state.trackId && details.trackId && state.trackId !== details.trackId) return false;
      if (state.ownerKey && details.ownerKey && state.ownerKey !== details.ownerKey) return false;
      return true;
    }

    function sourceMatchesSaved() {
      const expected = savedSource();
      if (!expected || currentSource() !== expected) return false;
      if (state.trackId && audio.dataset.pcTrackId && state.trackId !== audio.dataset.pcTrackId) return false;
      if (state.ownerKey && audio.dataset.pcOwnerKey && state.ownerKey !== audio.dataset.pcOwnerKey) return false;
      return true;
    }

    function rawTrackButtons() {
      return Array.from(document.querySelectorAll(PLAYER_SELECTOR)).filter(function (button) {
        return !button.closest("#pc-sticky-player") && Boolean(buttonDetails(button).src);
      });
    }

    function trackButtons() {
      const seen = new Set();
      return rawTrackButtons().filter(function (button) {
        const details = buttonDetails(button);
        const source = absoluteUrl(details.src);
        const identity = details.ownerKey && details.trackId
          ? details.ownerKey + "::" + details.trackId
          : source;
        if (!source || seen.has(identity)) return false;
        seen.add(identity);
        return true;
      });
    }

    function buttonForCurrentAudio() {
      return rawTrackButtons().find(buttonMatchesCurrentAudio) || null;
    }

    function buttonForSavedState() {
      return rawTrackButtons().find(buttonMatchesSavedState) || null;
    }

    function setCover(url) {
      const nextUrl = absoluteUrl(url || "");
      if (nextUrl === lastCoverUrl) return;
      lastCoverUrl = nextUrl;

      if (nextUrl) {
        stickyCover.src = nextUrl;
        stickyCover.hidden = false;
        stickyCoverFallback.hidden = true;
      } else {
        stickyCover.removeAttribute("src");
        stickyCover.hidden = true;
        stickyCoverFallback.hidden = false;
      }
    }

    function applyButtonMetadata(button) {
      if (!button) return;
      const details = buttonDetails(button);
      if (details.title) state.title = details.title;
      if (details.meta) state.meta = details.meta;
      if (details.cover) state.cover = absoluteUrl(details.cover);
    }

    function selectButton(button, options) {
      if (!button) return false;
      const details = buttonDetails(button);
      const source = absoluteUrl(details.src || "");
      if (!source) return false;

      const settings = options || {};
      const alreadyCurrent = buttonMatchesCurrentAudio(button);
      activeButton = button;
      state.src = source;
      state.trackId = details.trackId || source;
      state.ownerKey = details.ownerKey || window.location.pathname;
      audio.dataset.pcTrackId = state.trackId;
      audio.dataset.pcOwnerKey = state.ownerKey;
      applyButtonMetadata(button);
      state.hasUserSelected = true;
      state.sessionToken = sessionToken;
      state.navigationArmed = false;
      state.navigationSavedAt = 0;
      state.trackEnded = false;

      if (alreadyCurrent) {
        if (Number.isFinite(audio.currentTime)) state.currentTime = audio.currentTime;
        if (Number.isFinite(audio.duration)) state.duration = audio.duration;
      } else if (settings.resetTime !== false) {
        state.currentTime = 0;
        state.duration = 0;
      }

      if (typeof settings.userPaused === "boolean") {
        state.userPaused = settings.userPaused;
      }

      if (typeof settings.shouldResume === "boolean") {
        state.shouldResume = settings.shouldResume;
      }

      return true;
    }

    function adoptCurrentPageAudio(options) {
      const button = buttonForCurrentAudio();
      if (!button) return false;

      const settings = options || {};
      const playing = !audio.paused && !audio.ended;
      selectButton(button, {
        resetTime: false,
        userPaused: settings.userPaused === true,
        shouldResume: typeof settings.shouldResume === "boolean" ? settings.shouldResume : playing
      });

      if (playing) {
        state.userPaused = false;
        state.shouldResume = true;
        state.trackEnded = false;
      }

      persistState(true, state.shouldResume);
      return true;
    }

    function persistState(forceSave, playbackIntent) {
      const savedAt = Date.now();
      if (!forceSave && savedAt - lastSaveTime < 700) return;
      lastSaveTime = savedAt;

      if (sourceMatchesSaved()) {
        const matchingButton = buttonForSavedState();
        if (matchingButton) applyButtonMetadata(matchingButton);
        if (Number.isFinite(audio.currentTime)) state.currentTime = audio.currentTime;
        if (Number.isFinite(audio.duration)) state.duration = audio.duration;
      }

      state.title = state.title || "Select a beat";
      state.meta = state.meta || "Preview player";
      state.cover = state.cover || "";
      state.volume = Number.isFinite(audio.volume) ? audio.volume : 0.85;

      if (typeof playbackIntent === "boolean") {
        state.shouldResume = playbackIntent;
      }

      state.shouldResume = Boolean(
        state.shouldResume &&
        state.hasUserSelected &&
        state.sessionToken === sessionToken &&
        state.src &&
        !state.userPaused &&
        !state.trackEnded
      );

      state.savedAt = savedAt;
      writeState(state);
    }

    function syncSticky() {
      const matches = sourceMatchesSaved();
      const playing = matches && !audio.paused && !audio.ended;
      const isMuted = audio.muted || audio.volume === 0;
      const duration = matches && Number.isFinite(audio.duration)
        ? audio.duration
        : Number(state.duration) || 0;
      const currentTime = matches && Number.isFinite(audio.currentTime)
        ? audio.currentTime
        : Number(state.currentTime) || 0;
      const percentage = duration > 0 ? (currentTime / duration) * 100 : 0;
      const buttons = trackButtons();

      stickyTitle.textContent = state.title || "Select a beat";
      stickyMeta.textContent = state.meta || "Preview player";
      setCover(state.cover || "");

      const resumePending = Boolean(
        state.src &&
        !playing &&
        state.hasUserSelected &&
        state.sessionToken === sessionToken &&
        !state.userPaused &&
        !state.trackEnded &&
        (resumeRequested || state.shouldResume)
      );

      sticky.classList.toggle("is-playing", playing);
      sticky.classList.toggle("is-muted", isMuted);
      sticky.classList.toggle("is-resume-pending", resumePending);
      stickyToggle.disabled = !state.src;
      stickyPrev.disabled = buttons.length < 2;
      stickyNext.disabled = buttons.length < 2;
      stickyProgress.disabled = !state.src || duration <= 0;

      stickyToggle.setAttribute(
        "aria-label",
        playing ? "Pause track" : (resumePending ? "Tap to resume track" : "Play track")
      );
      stickyMute.setAttribute("aria-label", isMuted ? "Unmute track" : "Mute track");
      stickyMute.setAttribute("aria-pressed", isMuted ? "true" : "false");

      if (document.activeElement !== stickyProgress) {
        stickyProgress.value = Math.max(0, Math.min(100, percentage));
      }

      stickyCurrent.textContent = formatTime(currentTime);
      stickyDuration.textContent = formatTime(duration);
      setRangeFill(stickyProgress, percentage);

      if (document.activeElement !== stickyVolume) {
        stickyVolume.value = isMuted ? 0 : audio.volume;
      }
      setRangeFill(stickyVolume, (isMuted ? 0 : audio.volume) * 100);
      persistState(false);
    }

    function restoreTime() {
      if (!sourceMatchesSaved()) return;
      if (!pendingRestoreTime || !Number.isFinite(audio.duration) || audio.duration <= 0) return;
      audio.currentTime = Math.min(pendingRestoreTime, Math.max(0, audio.duration - 0.1));
      pendingRestoreTime = 0;
    }

    function removeResumeInteractionListeners() {
      if (!resumeListenersInstalled) return;
      resumeListenersInstalled = false;
      document.removeEventListener("pointerup", resumeAfterInteraction, true);
      document.removeEventListener("click", resumeAfterInteraction, true);
      document.removeEventListener("keydown", resumeAfterInteraction, true);
    }

    function resumeAfterInteraction(event) {
      if (!resumeRequested) {
        removeResumeInteractionListeners();
        return;
      }

      if (event && event.target instanceof Element && event.target.closest("#pc-sticky-player")) {
        return;
      }

      attemptCrossPageResume();
    }

    function installResumeInteractionListeners() {
      if (resumeListenersInstalled || !resumeRequested) return;
      resumeListenersInstalled = true;
      document.addEventListener("pointerup", resumeAfterInteraction, true);
      document.addEventListener("click", resumeAfterInteraction, true);
      document.addEventListener("keydown", resumeAfterInteraction, true);
      syncSticky();
    }

    function attemptCrossPageResume() {
      if (!resumeRequested || !state.src || pageIsLeaving) return;

      const expectedSource = savedSource();
      if (!expectedSource) return;

      if (currentSource() !== expectedSource) {
        audio.src = expectedSource;
        pendingRestoreTime = Number(state.currentTime) || 0;
        try { audio.load(); } catch (error) {}
      }

      restoreTime();

      let playPromise;
      try {
        playPromise = audio.play();
      } catch (error) {
        installResumeInteractionListeners();
        return;
      }

      if (playPromise && typeof playPromise.then === "function") {
        playPromise
          .then(function () {
            resumeRequested = false;
            state.userPaused = false;
            state.trackEnded = false;
            state.navigationArmed = false;
            state.navigationSavedAt = 0;
            state.shouldResume = true;
            removeResumeInteractionListeners();
            persistState(true, true);
            syncSticky();
          })
          .catch(function () {
            installResumeInteractionListeners();
          });
      } else if (!audio.paused) {
        resumeRequested = false;
        state.userPaused = false;
        state.trackEnded = false;
        state.navigationArmed = false;
        state.navigationSavedAt = 0;
        state.shouldResume = true;
        removeResumeInteractionListeners();
        persistState(true, true);
        syncSticky();
      } else {
        installResumeInteractionListeners();
      }
    }

    function captureTrackClick(button) {
      const details = buttonDetails(button);
      const source = absoluteUrl(details.src || "");
      const isCurrent = buttonMatchesCurrentAudio(button);

      return {
        button: button,
        source: source,
        wasCurrent: isCurrent,
        wasPlaying: Boolean(isCurrent && !audio.paused && !audio.ended),
        capturedAt: Date.now()
      };
    }

    function finishTrackClick(button, intent) {
      const details = buttonDetails(button);
      const clickedSource = absoluteUrl(details.src || (intent && intent.source) || "");
      if (!clickedSource) return;

      const sourceIsCurrent = buttonMatchesCurrentAudio(button);
      const userPausedCurrent = Boolean(
        intent &&
        intent.wasCurrent &&
        intent.wasPlaying &&
        sourceIsCurrent &&
        audio.paused
      );

      selectButton(button, {
        resetTime: !sourceIsCurrent,
        userPaused: userPausedCurrent,
        shouldResume: sourceIsCurrent && !audio.paused && !audio.ended
      });

      if (userPausedCurrent) {
        resumeRequested = false;
        state.shouldResume = false;
        persistState(true, false);
        syncSticky();
        return;
      }

      if (isFallbackAudio && !sourceIsCurrent) {
        audio.src = clickedSource;
        audio.currentTime = 0;
        try { audio.load(); } catch (error) {}
      }

      if (currentSource() === clickedSource && (audio.paused || audio.ended)) {
        /* Safe play assist: it never changes a page player's chosen source. */
        const playPromise = audio.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {
            resumeRequested = true;
            installResumeInteractionListeners();
          });
        }
      }

      state.userPaused = false;
      state.trackEnded = false;
      state.shouldResume = true;
      resumeRequested = false;
      persistState(true, true);
      syncSticky();
    }

    function capturePageControl(control) {
      return {
        control: control,
        source: currentSource(),
        wasPlaying: !audio.paused && !audio.ended,
        capturedAt: Date.now()
      };
    }

    function finishPageControl(intent) {
      if (!intent || Date.now() - intent.capturedAt > 1800) return;

      const current = currentSource();
      const sourceUnchanged = current && current === intent.source;
      const manuallyPaused = Boolean(intent.wasPlaying && sourceUnchanged && audio.paused);

      if (manuallyPaused && sourceMatchesSaved()) {
        state.userPaused = true;
        state.shouldResume = false;
        resumeRequested = false;
        persistState(true, false);
        syncSticky();
        return;
      }

      if (adoptCurrentPageAudio({
        userPaused: false,
        shouldResume: !audio.paused && !audio.ended
      })) {
        state.userPaused = false;
        state.trackEnded = false;
        state.shouldResume = !audio.paused && !audio.ended;
        persistState(true, state.shouldResume);
      }

      syncSticky();
    }

    function stepThroughPage(direction) {
      const buttons = trackButtons();
      if (!buttons.length) return;

      let index = -1;
      if (savedSource()) index = buttons.findIndex(buttonMatchesSavedState);

      if (index < 0) index = direction > 0 ? -1 : 0;
      const nextIndex = (index + direction + buttons.length) % buttons.length;
      buttons[nextIndex].click();
    }

    stickyCollapse.addEventListener("click", function () {
      applyDockCollapsed(!state.dockCollapsed, true);
    }, { signal: signal });

    stickyToggle.addEventListener("click", function () {
      const expectedSource = savedSource();
      if (!expectedSource) return;

      const playing = sourceMatchesSaved() && !audio.paused && !audio.ended;

      if (playing) {
        resumeRequested = false;
        removeResumeInteractionListeners();
        state.userPaused = true;
        state.trackEnded = false;
        state.navigationArmed = false;
        state.navigationSavedAt = 0;
        state.shouldResume = false;
        audio.pause();
        persistState(true, false);
      } else {
        if (currentSource() !== expectedSource) {
          audio.src = expectedSource;
          pendingRestoreTime = Number(state.currentTime) || 0;
          try { audio.load(); } catch (error) {}
        }

        state.userPaused = false;
        state.trackEnded = false;
        state.navigationArmed = false;
        state.navigationSavedAt = 0;
        state.shouldResume = true;
        resumeRequested = true;
        persistState(true, true);
        attemptCrossPageResume();
      }

      later(syncSticky, 40);
      later(syncSticky, 180);
    }, { signal: signal });

    stickyPrev.addEventListener("click", function () {
      stepThroughPage(-1);
      later(syncSticky, 100);
    }, { signal: signal });

    stickyNext.addEventListener("click", function () {
      stepThroughPage(1);
      later(syncSticky, 100);
    }, { signal: signal });

    stickyProgress.addEventListener("input", function () {
      const percentage = Math.max(0, Math.min(100, Number(stickyProgress.value)));
      setRangeFill(stickyProgress, percentage);

      if (!sourceMatchesSaved()) {
        if (state.duration > 0) {
          state.currentTime = (percentage / 100) * Number(state.duration);
        }
        persistState(true);
        return;
      }

      if (Number.isFinite(audio.duration) && audio.duration > 0) {
        audio.currentTime = (percentage / 100) * audio.duration;
      }
      persistState(true);
    }, { signal: signal });

    const initialVolume = Number.isFinite(Number(state.volume)) ? Number(state.volume) : audio.volume;
    stickyVolume.value = initialVolume;
    setRangeFill(stickyVolume, initialVolume * 100);

    stickyVolume.addEventListener("input", function () {
      const volumeValue = Math.max(0, Math.min(1, Number(stickyVolume.value)));
      setRangeFill(stickyVolume, volumeValue * 100);

      try {
        audio.muted = false;
        audio.volume = volumeValue;
      } catch (error) {
        stickyVolume.disabled = true;
      }

      if (topVolume) {
        topVolume.value = volumeValue;
        topVolume.dispatchEvent(new Event("input", { bubbles: true }));
      }

      persistState(true);
      syncSticky();
    }, { signal: signal });

    stickyMute.addEventListener("click", function () {
      audio.muted = !audio.muted;
      persistState(true);
      syncSticky();
    }, { signal: signal });

    /* Capture the state before the page's own playback listener runs. */
    document.addEventListener("click", function (event) {
      if (!event.isTrusted) return;
      const target = event.target instanceof Element ? event.target.closest(PLAYER_SELECTOR) : null;
      if (!target || target.closest("#pc-sticky-player")) return;
      const intent = captureTrackClick(target);
      capturedTrackIntent = intent;

      /*
        Some producer templates stop click bubbling at the track button. Run a
        zero-delay fallback after their button handler so the dock still sees
        the final play/pause result and never keeps stale track information.
      */
      later(function () {
        if (capturedTrackIntent !== intent) return;
        capturedTrackIntent = null;
        finishTrackClick(target, intent);
      }, 0);
    }, { capture: true, signal: signal });

    /* Read the result after the page player has handled the click. */
    document.addEventListener("click", function (event) {
      if (!event.isTrusted) return;
      const target = event.target instanceof Element ? event.target.closest(PLAYER_SELECTOR) : null;
      if (!target || target.closest("#pc-sticky-player")) return;

      const intent = capturedTrackIntent && capturedTrackIntent.button === target
        ? capturedTrackIntent
        : captureTrackClick(target);
      capturedTrackIntent = null;

      later(function () { finishTrackClick(target, intent); }, 0);
      later(function () {
        if (savedSource() === absoluteUrl(buttonDetails(target).src)) {
          finishTrackClick(target, intent);
        }
      }, 120);
    }, { signal: signal });

    document.addEventListener("click", function (event) {
      if (!event.isTrusted) return;
      const control = event.target instanceof Element ? event.target.closest(PAGE_CONTROL_SELECTOR) : null;
      if (!control || control.closest("#pc-sticky-player")) return;
      capturedPageControlIntent = capturePageControl(control);
    }, { capture: true, signal: signal });

    document.addEventListener("click", function (event) {
      if (!event.isTrusted) return;
      const control = event.target instanceof Element ? event.target.closest(PAGE_CONTROL_SELECTOR) : null;
      if (!control || control.closest("#pc-sticky-player")) return;

      const intent = capturedPageControlIntent && capturedPageControlIntent.control === control
        ? capturedPageControlIntent
        : capturePageControl(control);
      capturedPageControlIntent = null;

      later(function () { finishPageControl(intent); }, 0);
      later(function () { finishPageControl(intent); }, 120);
    }, { signal: signal });

    function isRealPageNavigation(link) {
      if (!link || !link.href) return false;
      if (link.hasAttribute("download")) return false;
      if (link.target && link.target.toLowerCase() !== "_self") return false;

      const rawHref = link.getAttribute("href") || "";
      if (!rawHref || rawHref.startsWith("#")) return false;
      if (/^(mailto:|tel:|sms:|javascript:)/i.test(rawHref)) return false;

      try {
        const destination = new URL(link.href, window.location.href);
        const current = new URL(window.location.href);
        if (destination.origin !== current.origin) return false;

        const sameDocument =
          destination.pathname === current.pathname &&
          destination.search === current.search &&
          destination.hash;

        return !sameDocument;
      } catch (error) {
        return false;
      }
    }

    function playbackShouldContinue() {
      return Boolean(
        state.hasUserSelected &&
        state.sessionToken === sessionToken &&
        state.src &&
        !state.userPaused &&
        !state.trackEnded &&
        (
          (sourceMatchesSaved() && !audio.paused && !audio.ended) ||
          state.shouldResume ||
          resumeRequested
        )
      );
    }

    function markNavigationIntent() {
      pageIsLeaving = true;
      window.clearTimeout(navigationResetTimer);

      const shouldContinue = playbackShouldContinue();
      state.navigationArmed = shouldContinue;
      state.navigationSavedAt = shouldContinue ? Date.now() : 0;
      state.shouldResume = shouldContinue;
      persistState(true, shouldContinue);

      navigationResetTimer = window.setTimeout(function () {
        if (document.visibilityState === "visible") pageIsLeaving = false;
      }, 1400);
    }

    document.addEventListener("pointerdown", function (event) {
      const link = event.target instanceof Element ? event.target.closest("a[href]") : null;
      if (isRealPageNavigation(link)) markNavigationIntent();
    }, { capture: true, signal: signal });

    document.addEventListener("click", function (event) {
      const link = event.target instanceof Element ? event.target.closest("a[href]") : null;
      if (isRealPageNavigation(link)) markNavigationIntent();
    }, { capture: true, signal: signal });

    document.addEventListener("submit", markNavigationIntent, { capture: true, signal: signal });

    if (topVolume) {
      topVolume.addEventListener("input", syncSticky, { signal: signal });
    }

    ["timeupdate", "durationchange", "volumechange", "emptied"].forEach(function (eventName) {
      audio.addEventListener(eventName, syncSticky, { signal: signal });
    });

    audio.addEventListener("play", function () {
      if (!adoptCurrentPageAudio({ shouldResume: true })) {
        if (sourceMatchesSaved()) {
          state.userPaused = false;
          state.trackEnded = false;
          state.shouldResume = true;
          persistState(true, true);
        }
      }

      resumeRequested = false;
      removeResumeInteractionListeners();
      syncSticky();
    }, { signal: signal });

    audio.addEventListener("pause", function () {
      /* Manual pauses are recorded by the clicked control handlers above. */
      if (sourceMatchesSaved() && !state.userPaused && !state.trackEnded) {
        state.shouldResume = true;
        persistState(true, true);
      }
      syncSticky();
    }, { signal: signal });

    audio.addEventListener("ended", function () {
      window.clearTimeout(endedTimer);
      endedTimer = window.setTimeout(function () {
        if (!sourceMatchesSaved() || !audio.ended) return;
        state.trackEnded = true;
        state.userPaused = false;
        state.shouldResume = false;
        resumeRequested = false;
        persistState(true, false);
        syncSticky();
      }, 80);
    }, { signal: signal });

    audio.addEventListener("loadedmetadata", function () {
      if (sourceMatchesSaved()) {
        if (Number.isFinite(audio.duration)) state.duration = audio.duration;
        restoreTime();
        persistState(true, state.shouldResume);
      }
      syncSticky();
      attemptCrossPageResume();
    }, { signal: signal });

    audio.addEventListener("canplay", function () {
      if (resumeRequested) attemptCrossPageResume();
    }, { signal: signal });

    function saveBeforeNavigation() {
      pageIsLeaving = true;
      const shouldContinue = playbackShouldContinue();
      state.navigationArmed = shouldContinue;
      state.navigationSavedAt = shouldContinue ? Date.now() : 0;
      state.shouldResume = shouldContinue;
      persistState(true, shouldContinue);
    }

    window.addEventListener("pagehide", saveBeforeNavigation, { signal: signal });
    window.addEventListener("beforeunload", saveBeforeNavigation, { signal: signal });
    window.addEventListener("freeze", saveBeforeNavigation, { signal: signal });

    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") {
        const shouldContinue = playbackShouldContinue();
        state.shouldResume = shouldContinue;
        persistState(true, shouldContinue);
        return;
      }

      pageIsLeaving = false;
      Object.assign(state, readState());
      pendingRestoreTime = Number(state.currentTime) || pendingRestoreTime || 0;
      resumeRequested = Boolean(
        state.hasUserSelected &&
        state.sessionToken === sessionToken &&
        state.src &&
        state.shouldResume &&
        !state.userPaused &&
        !state.trackEnded &&
        audio.paused
      );
      attemptCrossPageResume();
    }, { signal: signal });

    window.addEventListener("pageshow", function () {
      pageIsLeaving = false;
      window.clearTimeout(navigationResetTimer);
      Object.assign(state, readState());
      pendingRestoreTime = Number(state.currentTime) || pendingRestoreTime || 0;
      resumeRequested = Boolean(
        state.hasUserSelected &&
        state.sessionToken === sessionToken &&
        state.src &&
        state.shouldResume &&
        !state.userPaused &&
        !state.trackEnded &&
        audio.paused
      );
      attemptCrossPageResume();
    }, { signal: signal });

    const audioObserver = new MutationObserver(syncSticky);
    audioObserver.observe(audio, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ["src"]
    });
    observers.push(audioObserver);

    window.__pcSoundDockCleanup = function () {
      const shouldContinue = playbackShouldContinue();
      state.navigationArmed = shouldContinue;
      state.navigationSavedAt = shouldContinue ? Date.now() : 0;
      state.shouldResume = shouldContinue;
      persistState(true, shouldContinue);
      removeResumeInteractionListeners();
      window.clearTimeout(navigationResetTimer);
      window.clearTimeout(endedTimer);
      timers.forEach(function (timer) { window.clearTimeout(timer); });
      timers.clear();
      controller.abort();
      observers.forEach(function (observer) { observer.disconnect(); });
      document.body.classList.remove("pc-sound-dock-collapsed");
      window.__pcSoundDockCleanup = null;
    };

    syncSticky();

    resumeRequested = Boolean(
      recentNavigation &&
      state.hasUserSelected &&
      state.sessionToken === sessionToken &&
      state.src &&
      !state.userPaused &&
      !state.trackEnded
    );

    if (resumeRequested) {
      installResumeInteractionListeners();
      later(attemptCrossPageResume, 0);
      later(attemptCrossPageResume, 220);
      later(attemptCrossPageResume, 750);
    }
  }

  function start() {
    /* Let inline producer/product player scripts finish their own setup first. */
    window.setTimeout(function () { initSoundDock(false); }, 50);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", function () {
    window.setTimeout(function () { initSoundDock(true); }, 80);
  });
})();
